import { auth as authApi } from '@/api/api';
import { query } from '@/utils/url';
import controller from '@/utils/controller';
import userRoles from '../utils/userRoles';
import checkAppPermission from '../utils/checkAppPermission';
import * as authTokenManager from '../utils/tokenManager';
import parseUserData from '../utils/parseUserData';
import setAuthenticated from './setAuthenticated';
import resetUser from './resetUser';

const readyController = controller('ready');

export default {
  async login(data) {
    const {
      accessToken,
      otpEnabled,
      smsCodeRequired,
      ...verificationData
    } = await authApi.login(data);

    if (otpEnabled || smsCodeRequired) {
      sessionStorage.setItem('otp-req-token', accessToken);
      return {
        otpEnabled,
        smsCodeRequired,
        ...verificationData,
      };
    }

    return this.loginWithToken(accessToken);
  },
  async loginWithOTP(otp) {
    const token = sessionStorage.getItem('otp-req-token');
    if (!token) throw Error('OTP Request token not found!');
    const { accessToken } = await authApi.verifyOTP({ otp, token });
    return this.loginWithToken(accessToken);
  },
  async verifySMSCode(code) {
    const token = sessionStorage.getItem('otp-req-token');
    if (!token) throw Error('OTP Request token not found!');
    const { accessToken } = await authApi.verifySMSCode({ code, token });
    return this.loginWithToken(accessToken);
  },
  async resendSMS() {
    const token = sessionStorage.getItem('otp-req-token');
    if (!token) throw Error('OTP Request token not found!');
    return authApi.resendSMS(token);
  },
  async logout() {
    resetUser(this);
  },
  async loginWithToken(token) {
    try {
      authTokenManager.setToken(token);
      const user = await this.fetchUser();
      setAuthenticated(this, user);
    } catch (error) {
      resetUser(this);
      throw error;
    }
  },
  async fetchUser() {
    const userData = await authApi.getUserData();
    const parsedUserData = parseUserData(userData);
    const roles = userRoles(parsedUserData);

    const userDataWithRoles = {
      ...parsedUserData,
      roles,
    };

    return userDataWithRoles;
  },
  async refresh() {
    const { accessToken } = await authApi.refresh();
    authTokenManager.setToken(accessToken);
  },
  onReady(fn) {
    if (this.ready) return fn();
    readyController.onReady(fn);
  },
  async init() {
    const queryToken = query('token');
    const storedToken = authTokenManager.getToken();

    try {
      if (queryToken || storedToken)
        await this.loginWithToken(queryToken || storedToken);
    } finally {
      this.ready = true;
      readyController.ready();
      readyController.flush();
    }
  },
  check(role) {
    if (!this.user || !role) return false;
    const hasTheRole = r => this.user.roles.includes(r);
    if (Array.isArray(role)) return role.some(hasTheRole);
    return hasTheRole(role);
  },
  checkAppPermission,

  user: null,
  isLoggedIn: Boolean(authTokenManager.getToken()),
  redirectAfterLogin: null,
  ready: false,
};
